const map = {
	"./10.5mm.svg": 36989,
	"./10mm.svg": 74450,
	"./11mm.svg": 66327,
	"./5.5mm.svg": 9673,
	"./5mm.svg": 31998,
	"./6.5mm.svg": 38318,
	"./6mm.svg": 4197,
	"./7.5mm.svg": 5991,
	"./7mm.svg": 20584,
	"./8.5mm.svg": 65108,
	"./8mm.svg": 31135,
	"./9.5mm.svg": 22197,
	"./9mm.svg": 72986,
	"./display.svg": 77147
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82514;